/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { connectRouter } from 'connected-react-router';
import { combineReducers } from 'redux';
import Auth from './auth';
import Presentation from './presentation';
import ExchangeOrders from './exchange-orders';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default (history: any) =>
  combineReducers({
    auth: Auth.reducer,
    presentation: Presentation.reducer,
    exchangeOrders: ExchangeOrders.reducer,
    router: connectRouter(history),
  });
